import React, {useMemo} from 'react';
import TabsTemplate from "../../../common/components/TabsTemplate";
import Template from "./_1";
import Constructor from "./_2";
import Variation from "./_3";
import Properties from "./_4";
import {SELECTORS_LINK} from "../../../../utils/constants";
import mobileImg from "/public/selectors/features/design.png";
import {SEL_NAMESPACE} from "../../../../utils/i18nNameSpaces";

const Customization = () => {
  const stateList = [
    "_1",
    "_2",
    "_3",
    "_4"
  ]

  const componentsList = useMemo(() => (
    [
      <Template/>,
      <Constructor/>,
      <Variation/>,
      <Properties/>
    ]
  ), [])

  return (
    <>
      <TabsTemplate
        stateList={stateList}
        componentsList={componentsList}
        namespace={SEL_NAMESPACE}
        link={SELECTORS_LINK}
        mobileImg={mobileImg}
        content={"simplified"}
      />
    </>
  );
};

export default Customization;